export enum AccordionStatus {
  Informative = 'Informative',
  Warning = 'Warning',
  Danger = 'Danger',
  Caution = 'Caution',
  Healthy = 'Healthy',
  Neutral = 'Neutral',
}
